<div class="fixed-section">
    <section class="titleBarBg fixed-top">
        <div class="container-fluid">
            <div class="row mar-7px">
                <div class="w-3">
                    <img src="assets/images/manageprojects.svg" class="pageIcon" alt="">
                </div>
                <div class="w-97">
                    <div class="pageHeadingBar">
                        <div class="row">
                            <div class="col-md-6 align-self-center">
                                <h6 class="pageHeadingText mb-0 text-uppercase"> MANAGE PROJECT</h6>
                            </div>
                            <div class="col-md-3 align-self-center">
                            </div>
                            <div class="col-md-3 align-self-center text-end">
                                <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                        <img src="assets/images/export.png" class="me-1 w-25px pointerCursor" alt=""
                                            title="Export" (click)="exportProjectData()">
                                    </li>
                                    <li class="list-inline-item">
                                        <div class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle urserName" href="#" role="button"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="assets/images/filter.png" class="w-20px me-2" alt=""
                                                    title="Filter">
                                            </a>
                                            <ul class="dropdown-menu customMargindrp w-300">
                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>CATEGORY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="categoryList"
                                                            [(ngModel)]="selectedCategories" name="category"
                                                            [showHeader]="true" [filter]="true"
                                                            placeholder="Select Category"
                                                            (click)="stopPropagation($event)">
                                                            <ng-template pTemplate="header">
                                                                <div class="custom-multiselect-header">
                                                                    <span style="padding-right: 5px;">SELECT ALL</span>
                                                                </div>
                                                            </ng-template>
                                                        </p-multiSelect>
                                                    </div>
                                                </div>
                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>AGENCY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="agencies"
                                                            [(ngModel)]="selectedAgencies" name="agency"
                                                            [showHeader]="true" [filter]="true"
                                                            placeholder="Select Agency"
                                                            (click)="stopPropagation($event)"></p-multiSelect>
                                                    </div>
                                                </div>
                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>STATUS</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <p-multiSelect [options]="statuses" [(ngModel)]="selectedStatus"
                                                            name="status" [showHeader]="true" [filter]="true"
                                                            placeholder="Select Status"
                                                            (click)="stopPropagation($event)"></p-multiSelect>
                                                    </div>
                                                </div>
                                                <div class="row ">
                                                    <div class="offset-md-5 col-md-7 ps-0">
                                                        <button class="btn progressBtn w-100" role="button"
                                                            (click)="getProjectData()">
                                                            APPLY FILTER
                                                        </button>
                                                    </div>
                                                </div>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="middleContent">
    <section class="mt-131">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="card border-0 stepsBars-2 mb-5">
                        <div class="card-body">
                            <div class="main mx-0 pb-1">
                                <table class="table datatable border-x-0 mb-0">
                                    <tbody>
                                        <tr class="subheaderrr">
                                            <th width="18%" colspan="2">
                                                PROJECT TITLE
                                            </th>

                                            <th width="10%">
                                                CATEGORY
                                            </th>
                                            <th width="12%">
                                                REQUESTED BY
                                            </th>
                                            <th width="10%" (click)="sortProjects('initiatedDate')"
                                                style="cursor:pointer;">
                                                INITIATED DATE
                                                <img *ngIf="sortColumn === 'initiatedDate'"
                                                    [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'"
                                                    class="ms-1 w-10" />
                                            </th>
                                            <th width="9%" (click)="sortProjects('startDate')" style="cursor:pointer;">
                                                START DATE
                                                <img *ngIf="sortColumn === 'startDate'" 
                                                       [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'" 
                                                       class="ms-1 w-10" />
                                            </th>
                                            <th width="8%" (click)="sortProjects('endDate')" style="cursor:pointer;">
                                                END DATE
                                                <img *ngIf="sortColumn === 'endDate'" 
                                                       [src]="sortDirection === 'asc' ? 'assets/images/up-arrow.png' : 'assets/images/down-arrow.png'" 
                                                       class="ms-1 w-10" />
                                            </th>
                                            <th width="5%">
                                                PWR #
                                            </th>
                                            <th width="5%">
                                                STORES
                                            </th>
                                            <th width="4%">
                                                Instructions
                                            </th>
                                            <th width="6%">
                                                AGENCY
                                            </th>
                                            <th class="border-end-0" width="10%">
                                                STATUS
                                            </th>
                                        </tr>
                                        <tr *ngFor="let proj of projects;">
                                            <td width="2%" class="vertical-align-middle text-center titleTdBg">
                                                <a (click)="navigateToComponent(proj.refId,proj.categoryIds)">
                                                    <img src="assets/images/pencilIocn.svg" class="me-1 w-21" alt=""
                                                        style="cursor: pointer;" title="Edit">
                                                </a>
                                            </td>
                                            <td class="text-start vertical-align-middle titleTdBg">
                                                {{proj.projectTitle}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{proj.category}}
                                            </td>
                                            <td class="text-start vertical-align-middle">
                                                <strong>{{proj.requestedBy}}</strong>
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{proj.initiatedDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{proj.startDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                {{proj.endDate}}
                                            </td>
                                            <td class="text-center vertical-align-middle" width="5%">
                                                {{proj.pwR_Id}}
                                            </td>
                                            <td class="text-center vertical-align-middle">
                                                <div class="d-flex justify-content-between">
                                                    <div class="align-self-center">
                                                        {{proj.numberOfStores}}
                                                    </div>
                                                    <div *ngIf="proj.numberOfStores > 0">
                                                        <img src="assets/images/download_icon.svg" alt=""
                                                            class="pointerCursor"
                                                            (click)="downloadStoresExcel($event,proj.refId, proj.projectTitle)">
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="d-block justify-content-between">
                                                    <div *ngIf="proj.canDownloadInstructions">
                                                        <img src="assets/images/download_icon.svg" alt=""
                                                            class="pointerCursor"
                                                            (click)="downloadInstruction($event,proj.refId, proj.projectTitle)">
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <strong>{{proj.agencyName}}</strong>
                                            </td>
                                            <td class="text-start vertical-align-middle status_td">
                                                <div class="nav-item dropdown d-flex justify-content-between">
                                                    <div>
                                                        <span class="draftTextColor">{{proj.status}}</span>
                                                    </div>
                                                    <div>
                                                        <a class="nav-link dropdown-toggle urserName" href="#"
                                                            role="button" data-bs-toggle="dropdown"
                                                            aria-expanded="false">
                                                            <img src="assets/images/down_arrow.png" class="w-17" alt="">
                                                        </a>
                                                        <ul class="dropdown-menu customMargindrp w-400">
                                                            <div class="tableFixHead">
                                                                <table class="table datatable border-x-0 mb-0">
                                                                    <thead>
                                                                        <tr class="subheaderrr">
                                                                            <th width="2%"></th>
                                                                            <th width="10%" class="text-start">
                                                                                DATE
                                                                            </th>
                                                                            <th width="15%" class="text-start">
                                                                                STATUS
                                                                            </th>
                                                                            <th width="20%" class="text-start">
                                                                                UPDATED BY
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            *ngFor="let projStatus of proj.projectStatuses">
                                                                            <td>
                                                                                <img src="assets/images/check-mark.png"
                                                                                    class="tableTickmark" alt=""
                                                                                    *ngIf="projStatus.updatedDate != null">
                                                                            </td>
                                                                            <td class="text-start ">
                                                                                <span
                                                                                    class="textNavyblue">{{projStatus.updatedDate}}</span>
                                                                            </td>
                                                                            <td class="text-start draftTextColor">
                                                                                {{projStatus.projectStatusText}}
                                                                            </td>
                                                                            <td>
                                                                                {{projStatus.updatedBy}}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="card" *ngIf="projects!.length === 0 ">
                                    <div class="card-body py-2 px-3">
                                        <div class="emtyCard p-0">
                                            <p class="mb-0">No Records Found
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>